import request from '@/utils/request'

export function updateActivityCoinCfg(data) {
  return request({
    url: 'api/v1/activity-coin/updateList',
    method: 'post',
    data: data
  })
}

export function getActivityCoinCfgList(data) {
  return request({
    url: 'api/v1/activity-coin/getList',
    method: 'post',
    data: data
  })
}

export function getStealMaxList(data) {
  return request({
    url: 'api/v1/activity-coin/getStealMaxList',
    method: 'post',
    data: data
  })
}

export function getFirstCfgList(data) {
  return request({
    url: 'api/v1/activity-coin/getFirst',
    method: 'post',
    data: data
  })
}

export function exportActivityCoinCfg() {
  return request({
    url: 'api/v1/activity-coin/export',
    method: 'get'
  })
}

export function exportStealMaxCfg() {
  return request({
    url: 'api/v1/activity-coin/exportStealMax',
    method: 'get'
  })
}

export function importActivityCoinCfg(data) {
  return request({
    url: 'api/v1/activity-coin/import',
    method: 'post',
    data: data,
    timeout: 50000
  })
}

export function importStealMaxCfg(data) {
  return request({
    url: 'api/v1/activity-coin/importStealMax',
    method: 'post',
    data: data,
    timeout: 50000
  })
}

export function delActivityCoinCfg(data) {
  return request({
    url: 'api/v1/activity-coin/del',
    method: 'delete',
    data: data
  })
}

